// Same-site relative paths only: blocks absolute URLs, protocol-relative, backslash and control-character tricks.
export const safeNext = (p) =>
  typeof p === "string" && p.startsWith("/") && !p.startsWith("//") && !p.includes("\\") && !/[\u0000-\u001f]/.test(p) ? p : null;
